<template>
    <b-container fluid="">
        <b-button type="button" id="btn_flotante_agregar" size="sm" variant="outline-dark"
            v-if="permisos.sucursales?.crear || ES_ROOT" @click="abrir_modal_crear_articulo"><i
                class="fas fa-store"></i>
            Agregar Sucursal</b-button>
        <b-button type="button" id="btn_flotante_agregar" size="sm" variant="outline-dark" v-else disabled>
            <i class="fas fa-store"></i> Agregar Sucursal
        </b-button>

        <b-row>
            <div class="col-sm-12 mt-2">
                <h3>
                    Sucursales
                </h3>
            </div>
            <div class="col-sm-12 mt-2">
                <table class="table table-sm table-striped table-bordered" style="font-size: 10px;">
                    <thead>
                        <tr>
                            <th style="width: 10%;text-align: center;">
                                ID
                            </th>
                            <th style="width: 55%;">
                                Sucursal
                            </th>
                            <th style="width: 20%;">
                                Dirección
                            </th>
                            <th style="width: 15%;text-align: center;">
                                ...
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in sucursales" :key="index">
                            <td style="text-align: center;">
                                {{ item.codigo }}
                            </td>
                            <td>
                                {{ item.nombre }}
                            </td>
                            <td>
                                {{ item.direccion }}
                            </td>
                            <td style="text-align: center;">
                                <b-button type="button" size="sm" style="font-size: 10px;margin-right: 5px;"
                                    variant="outline-dark"
                                    v-if="permisos.sucursales?.borrar || datos_usuario.parametros.roles.includes('ROOT')"
                                    @click="borrar_registro(item)">
                                    <i class="fas fa-trash"></i>
                                </b-button>
                                <b-button type="button" size="sm" style="font-size: 10px;margin-right: 5px;"
                                    variant="outline-dark" v-else disabled>
                                    <i class="fas fa-trash"></i>
                                </b-button>

                                <b-button type="button" size="sm" style="font-size: 10px;margin-right: 5px;"
                                    variant="outline-dark"
                                    v-if="permisos.sucursales?.actualizar || datos_usuario.parametros.roles.includes('ROOT')"
                                    @click="abrir_modal_actualizar_articulo(item)">
                                    <i class="fas fa-pen"></i>
                                </b-button>
                                <b-button type="button" size="sm" style="font-size: 10px;margin-right: 5px;"
                                    variant="outline-dark" v-else disabled>
                                    <i class="fas fa-pen"></i>
                                </b-button>

                                <b-button type="button" size="sm" style="font-size: 10px;" variant="outline-dark"
                                    @click="abrir_ficha_sucursal(item)">
                                    <i class="fas fa-eye"></i>
                                </b-button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </b-row>

        <Formulario v-if="modal_crear_articulo" v-on:salir="cerrar_modal_crear_articulo"
            v-on:actualizar="actualizar_lista_sucursales" />

        <Actulizar v-if="modal_actualizar_articulo" :item="item" v-on:salir="cerrar_modal_actualizar_articulo"
            v-on:actualizar="actualizar_lista_sucursales" />

        <Ficha v-if="ficha_sucursal" v-on:salir="cerrar_ficha_sucursal" />
    </b-container>
</template>

<script>
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

    import Formulario from './Crear.vue'
    import Actulizar from './Actualizar.vue'
    import Ficha from './Ficha/Ficha.vue'

    import { atexto, minix, pregunta } from '../functions/alertas'

    export default {
        name: 'Lista',
        computed: {
            ...mapState(['id_empresa_seleccionada', 'sucursales', 'permisos', 'datos_usuario']),
            ...mapGetters(['ES_ROOT'])
        },
        components: {
            Formulario,
            Actulizar,
            Ficha
        },
        data() {
            return {
                modal_crear_articulo: false,
                modal_actualizar_articulo: false,
                ficha_sucursal: false,
                item: {}
            }
        },
        methods: {
            cerrar_modal_crear_articulo() {
                this.modal_crear_articulo = false
            },
            abrir_modal_crear_articulo() {
                this.modal_crear_articulo = true
            },
            cerrar_modal_actualizar_articulo() {
                this.modal_actualizar_articulo = false
            },
            abrir_modal_actualizar_articulo(item) {
                this.item = item
                this.modal_actualizar_articulo = true
            },
            async actualizar_lista_sucursales() {
                await this.$store.dispatch('obtener_sucursales')
            },
            abrir_ficha_sucursal(item) {
                this.set_sucursal_seleccionada(item)
                this.ficha_sucursal = true
            },
            cerrar_ficha_sucursal() {
                this.ficha_sucursal = false
            },
            async borrar_registro(item) {


                let j = {
                    api: `sucursales/c/referenciada?sucursal=${item.id}&empresa=${this.id_empresa_seleccionada}`,
                }

                let r = await this.obtener_data(j)
                if (r) {
                    atexto({
                        titulo: 'No se puede borrar',
                        cuerpo: 'La sucursal tiene referencias con productos',
                        icono: 'error'
                    })

                } else {

                    pregunta({ titulo: 'Seguro que deseas borrar el registro?', texto: 'Esta acción no se puede revertir', afirmacion: 'Si, borrar!' }, async (i) => {
                        if (i) {

                            let f = {
                                api: `sucursales/${item.documentId}`,
                            }

                            await this.borrar_data(f)
                            await this.actualizar_lista_sucursales()

                        }
                    })

                }

            },
            ...mapActions(['borrar_data', 'obtener_data']),
            ...mapMutations(['set_sucursal_seleccionada'])
        },
    }
</script>

<style>
    #btn_flotante_agregar {
        position: fixed;
        top: 60px;
        right: 15px;
        z-index: 999;
    }

</style>